import { render, staticRenderFns } from "./BookingsSchedulerBodyCell.vue?vue&type=template&id=c2198a6a&scoped=true"
import script from "./BookingsSchedulerBodyCell.vue?vue&type=script&lang=js"
export * from "./BookingsSchedulerBodyCell.vue?vue&type=script&lang=js"
import style0 from "./BookingsSchedulerBodyCell.vue?vue&type=style&index=0&id=c2198a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2198a6a",
  null
  
)

export default component.exports